export const isGarmentInFavorites = (favoritesList: Models.Garment[], current: Models.Garment) => {
    const res = favoritesList.find((item: Models.Garment) => item.garment_id === current.garment_id)
    return res
}

export const isLookInFavorites = (favoritesList: Models.Look[], current: Models.Look) => {
    const res = favoritesList.find((item: Models.Look) => item.look_id === current.look_id)
    return res
}
